<template>
  <div>
    <Header />
    <div>
      <section class="relative text-white pt-16 h-80 flex items-center">
        <!-- Background -->
        <div class="absolute inset-0 hero-gradient"></div>
        <div class="absolute inset-0 bg-black bg-opacity-30"></div>

        <!-- Content -->
        <div
          class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
        >
          <div class="flex items-center justify-center mb-4">
            <div class="bg-white bg-opacity-20 p-4 rounded-full mr-4">
              <svg
                class="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                ></path>
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                ></path>
              </svg>
            </div>
            <h1 class="text-4xl md:text-5xl font-bold animate-fade-in-up">
              Mentions légales
            </h1>
          </div>
          <p
            class="text-xl md:text-2xl opacity-90 max-w-3xl mx-auto animate-fade-in-up"
          >
            Association des Médecins Généralistes et Médecins de Famille d'Oran
          </p>
        </div>
      </section>

      <!-- FAQ Section -->
      <div
        class="max-w-4xl mt-8 mx-auto bg-white rounded-xl shadow-lg overflow-hidden"
      >
        <!-- Section Title -->
        <div class="bg-blue-700 text-white p-6">
          <h2 class="text-2xl font-bold flex items-center">
            <i class="fa fa-scale-balanced mr-3"></i> Mentions légales
          </h2>
          <p class="mt-2">
            Trouvez les informations dont vous avez besoin concernant notre
            association
          </p>
        </div>

        <div class="divide-y divide-gray-200">
          <div
            v-for="(item, index) in notices.questions"
            :key="index"
            class="p-6"
          >
            <h3
              class="text-xl font-semibold text-blue-800 mb-2 flex items-center"
            >
              <i class="fas fa-circle-question text-blue-500 mr-2"></i>
              {{ item.question }}
            </h3>
            <div class="text-gray-700 ml-7 mt-2" v-html="item.answer"></div>
          </div>
        </div>

        <!-- Contact Card -->
        <div class="bg-blue-50 p-6 border-t border-blue-200">
          <h3
            class="text-xl font-semibold text-blue-800 mb-4 flex items-center"
          >
            <i class="fa fa-envelope text-blue-500 mr-2"></i> Besoin de plus
            d'informations ?
          </h3>
          <p class="text-gray-700 mb-4">
            N'hésitez pas à nous contacter pour toute question supplémentaire.
          </p>
          <div class="flex flex-wrap gap-4">
            <a
              href="mailto:contact@amgoran.dz"
              class="flex items-center text-blue-600 hover:text-blue-800"
            >
              <i class="fa fa-envelope mr-2"></i> contact@amgoran.dz
            </a>
            <a
              href="tel:+213671153216"
              class="flex items-center text-blue-600 hover:text-blue-800"
            >
              <i class="fa fa-phone mr-2"></i> (+213) 671153216
            </a>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import notices from "../data/notices";
export default {
  name: "LegalNotices",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      notices: notices,
    };
  },
};
</script>
<style scoped>
.hero-gradient {
  background: linear-gradient(135deg, #4f6bb6 0%, #5a67a8 100%);
}
</style>
